"use client";

import { useEffect } from "react";
import Cookies from "js-cookie";

interface CookieManagerProps {
  affiliateId?: string;
  currency?: string;
}

const normalizeCurrency = (value?: string) => {
  const normalized = (value || "").trim().toUpperCase();
  return ["SAR", "USD", "EUR"].includes(normalized) ? normalized : null;
};

export default function CookieManager({
  affiliateId,
  currency,
}: CookieManagerProps) {
  useEffect(() => {
    const existingCurrency = normalizeCurrency(Cookies.get("currency"));
    const incomingCurrency = normalizeCurrency(currency);

    // Keep user's last selection. Only initialize when missing/invalid.
    if (!existingCurrency) {
      Cookies.set("currency", incomingCurrency || "SAR", {
        expires: 365,
        sameSite: "Lax",
      });
    }

    // Set affiliate_id cookie if provided
    if (affiliateId) {
      Cookies.set("affiliate_id", affiliateId, {
        expires: 365,
        sameSite: "Lax",
      });
    }
  }, [affiliateId, currency]);

  return null; // This component doesn't render anything
}
